import { useRouteLoaderData } from 'react-router-dom';
import { InitialProps } from '../../lib/types';
import { ROOT_ROUTE } from '../../lib/constants/routes';

export const useInitialProps = (): InitialProps => {
    const initialProps = useRouteLoaderData(ROOT_ROUTE) as InitialProps;
    return initialProps;
};
